import { PersonOutline } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Card,
  Divider,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../assets/css/MainpageCss.css";
import Breathe from "./breathe.gif";
import Integrations from "./integrations.png";
import Gif from "./gif.gif";
import Analytics from "./Analytics.png";
const MainPage = (props) => {
  const [email, setEmail] = useState("");
  const validateEmail = (mail) => {
    const emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(mail)) {
      return true;
    } else {
      return false;
    }
  };
  const [error, setError] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const theme = useTheme();
  const isXsScreen = useMediaQuery("(max-width:1000px)");
  const [visibility, setVisibility] = useState(Array(10).fill(true));

  useEffect(() => {
    let timerId = null;

    const handleScroll = () => {
      // clear the timer if it exists
      if (timerId !== null) {
        clearTimeout(timerId);
      }

      // set a timer to run your update function after a delay
      // this way it doesn't run too frequently
      timerId = setTimeout(() => {
        setVisibility((prevVisibility) => {
          const newVisibility = [...prevVisibility];

          for (let i = 0; i < newVisibility.length; i++) {
            if (window.pageYOffset > i * 400 && !newVisibility[i]) {
              newVisibility[i] = true;
            }
          }
          return newVisibility;
        });
      }, 200); // the delay in milliseconds
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timerId !== null) {
        clearTimeout(timerId);
      }
    };
  }, []);
  return (
    <div style={{ background: "white" }}>
      <div
        className="jumbotronOut"
        style={{
          minHeight: isXsScreen ? "864px" : "500px",
          marginTop: props.decodedToken ? "120px" : "98px",
        }}
      >
        <div
          className={`jumbotron ${isXsScreen ? "column" : ""}`}
          style={{ display: "flex", maxWidth: "1200px" }}
        >
          <div
            className="container"
            style={{
              width: isXsScreen ? "100%" : "55%",
              gap: "20px",
              flex: props.decodedToken ? "2.5" : "1",
            }}
          >
            <div
              className={"displayFlex align " + (isXsScreen ? "column" : "")}
              style={{ gap: "50px" }}
            >
              <div className="flex column">
                <h1
                  style={{
                    width: "100%",
                    textAlign: !props.decodedToken ? "center" : "left",
                    margin: 0,
                    fontSize:
                      60 -
                      props.decodedToken?.username?.split(" ")[0]?.length *
                        1.3 +
                      "px",
                  }}
                >
                  {props.decodedToken
                    ? "Welcome Back, " +
                      props.decodedToken?.username?.split(" ")[0]
                    : "Timely"}
                </h1>
                <p
                  style={{
                    width: "100%",
                    textAlign: !props.decodedToken ? "center" : "left",
                  }}
                >
                  {props.decodedToken
                    ? "Explore the powerful features of Timely that make managing your access to scheduling and availability easier than ever."
                    : "A simple and easy-to-use scheduling app."}
                </p>
                <div
                  style={{
                    display: props.decodedToken ? "flex" : "none",
                    gap: "5%",
                    width: "100%",
                  }}
                >
                  <Button
                    onClick={() => {
                      window.location.href = "/app/events";
                    }}
                    startIcon={<PersonOutline />}
                    variant="contained"
                    style={{
                      flex: 1,
                      borderRadius: "25px",
                      background: "#d9bca9",
                    }}
                  >
                    My Account
                  </Button>
                </div>
              </div>
              <div
                className="flex column"
                style={{
                  gap: "20px",
                  display: !props.decodedToken && "none",
                  margin: "0px 20px",
                }}
              >
                <Card
                  className="flex column transforms"
                  style={{
                    gap: "10px",
                    padding: "20px",
                    flex: 1,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <Typography
                    className="font"
                    fontWeight={700}
                    style={{ textAlign: "left" }}
                  >
                    Personalized Experience
                  </Typography>
                  <Typography style={{ textAlign: "left", fontSize: "17px" }}>
                    Customize your settings to suit your unique needs. With
                    Timely, you have the power to make your scheduling tool work
                    for you.
                  </Typography>
                </Card>
                <Card
                  className="flex column transforms"
                  style={{
                    gap: "10px",
                    padding: "20px",
                    flex: 1,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  }}
                >
                  <Typography
                    className="font"
                    fontWeight={700}
                    style={{ textAlign: "left" }}
                  >
                    Seamless Communication
                  </Typography>
                  <Typography style={{ textAlign: "left", fontSize: "16px" }}>
                    Keep everyone on the same page with instant notifications
                    and updates. Say goodbye to scheduling conflicts and
                    misunderstandings.
                  </Typography>
                </Card>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                display: "flex",
                gap: "5%",
                padding: "20px 0",
                width: "100%",
              }}
            >
              {!props.decodedToken ? (
                <>
                  <div
                    style={{
                      flex: 2,
                    }}
                  >
                    <OutlinedInput
                      value={email}
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        color: error && email ? "red" : "black",
                        paddingLeft: "2%",
                        width: "100%",
                      }}
                      placeholder="Enter your email"
                    />
                    {error && (
                      <InputLabel style={{ color: "red" }}>
                        Enter a valid email
                      </InputLabel>
                    )}
                  </div>
                  <Button
                    onClick={() => {
                      validateEmail(email)
                        ? (window.location.href = `/signup?email=${
                            email ? email : ""
                          }`)
                        : setError(true);
                    }}
                    variant="contained"
                    style={{
                      flex: isXsScreen ? 1.5 : 1,
                      background: "#d9bca9",
                      maxHeight: "51px",
                      fontSize: "15px",
                    }}
                  >
                    Get Started
                  </Button>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            className="container"
            style={{
              display: props.decodedToken && "none",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "500px",
                maxWidth: "400px",
              }}
              src={Breathe}
            />
          </div>
        </div>
      </div>
      <Divider />
      <Grid container className="flex justify" style={{ padding: "80px 0px" }}>
        <div
          className={"flex align" + (isXsScreen ? " column" : "")}
          style={{
            justifyContent: "center",
            gap: "30px",
            maxWidth: "70%",
          }}
        >
          <div style={{ gap: "25px",width:(isXsScreen ? " 100%" : "40%") }} className=" displayFlex column">
            <Typography variant="h4" className="font" fontWeight={800}>
              Advanced Analytics
            </Typography>
            <Typography variant="h6" className="font">
              Gain insights into your meetings' geographical spread, track
              bookings, spot trends, and identify your top customers to optimize
              your strategy. Discover the benefits of our premium plan today.
            </Typography>
          </div>
          <div
            className="flex align justify"
            style={{
              width:'100%'
            }}
          >
            <img
              style={{
                width: "100%",
                height: "auto",
                maxWidth: "600px",
              }}
              src={Analytics}
              alt="Analytics Dashboard"
              className="img-fluid"
            />
          </div>
        </div>
      </Grid>

      <footer className="footer">
        <div className="container">
          <p className="footer-text">
            &copy; 2023 Timely. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};
export default MainPage;
